// extracted by mini-css-extract-plugin
export const root = "subnav-module--root--Vnx94";
export const isActive = "subnav-module--isActive--2xQqC";